import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { useTrackScreenOpened, TRACKING_EVENTS } from '@services/tracking';
import { Machine } from '@interfaces/machines';

export const useTrackOperatorPanelOpened = () => {
  const selectedItem = useSelector(selectSelectedItem) as Machine;
  const { machineStatus } = selectedItem || {};

  useTrackScreenOpened(TRACKING_EVENTS.OPERATOR_PANEL, () => ({
    machineId: selectedItem?.machineId ? String(selectedItem.machineId) : '',
    machineName: selectedItem?.shortName || selectedItem?.fullName || '',
    machineBrand: selectedItem?.machineBrand?.name,
    machineProductivityStatus: machineStatus?.status || 'Not Productive',
    machineSubStatus: machineStatus?.subStatus,
    machineExecutionMode: machineStatus?.executionMode,
    isConnected: !!machineStatus?.isConnected,
    hasActiveBatch: !!machineStatus?.productionBatchId,
    hasActiveNcFile: !!machineStatus?.ncFile,
  }));
};
